import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import productReducer from './slices/productSlice';
import saleReducer from './slices/saleSlice';
import customerReducer from './slices/customerSlice';
import reportReducer from './slices/reportSlice';
import backupReducer from './slices/backupSlice';
import settingReducer from './slices/settingSlice';
import uiReducer from './slices/uiSlice';
import supplierReducer from './slices/supplierSlice';
import expenseReducer from './slices/expenseSlice';
import shiftReducer from './slices/shiftSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    sales: saleReducer,
    customers: customerReducer,
    reports: reportReducer,
    backups: backupReducer,
    settings: settingReducer,
    ui: uiReducer,
    suppliers: supplierReducer,
    expenses: expenseReducer,
    shift: shiftReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/loginUser/fulfilled', 'auth/registerUser/fulfilled'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
